/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener("zrx-slider-item-added", function (e) {
  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
    bubbles: true
  }));
});

function animateTitle(newTitle) {
  let currentState = false;
  origTitle = 'שרשראות של לאבי במבחר היסטרי';  // save original title
  animatedTitle = newTitle
  timer = setInterval(startAnimation, 2000);

  function startAnimation() {
    // animate between the original and the new title
    document.title = currentState ? origTitle : animatedTitle;
    currentState = !currentState;
  }
}

const necklace_length_input = document.querySelector('#necklace_length')
const variant_options = document.querySelectorAll('.variant-btn')

if(variant_options[0] != null) {
	necklace_length_input.value = variant_options[0].innerText;
}

variant_options.forEach(item => {
  item.addEventListener('click', function() {
   	 necklace_length_input.value = item.innerText;
      variant_options.forEach(item2 => {
        item2.classList.remove('selected')
      })
     item.classList.add('selected')
  }) 
})

function toggleGiftPopup() {
   if ($(".overlay").hasClass("is-on")) {
    $(".overlay").removeClass("is-on");
  } else {
    $(".overlay").addClass("is-on");
    document.documentElement.dispatchEvent(new CustomEvent('cart:close', {bubbles: true}));
  } 
}  


/*$('#gift-wrap').change(() => {
   if ($(".overlay").hasClass("is-on")) {
    $(".overlay").removeClass("is-on");
  } else {
    $(".overlay").addClass("is-on");
    document.documentElement.dispatchEvent(new CustomEvent('cart:close', {bubbles: true}));
  } 
})
*/

$('#close_giftwrap').on('click',() => {
  $(".overlay").removeClass("is-on");
  document.documentElement.dispatchEvent(new CustomEvent('cart:open', {bubbles: true}));  
})

$('.Add_Gift_Wrap').click(function(event) {
    const note = $('.GiftWrap__Note')
    const explain = $('.GiftWrap__Explain')
    const error = $('.Giftwrap__error')
  
    let variant = ""
    const currentQuantity = $('.gift_wrap_quantity .QuantitySelector__CurrentQuantity').val()
    let e = event || window.event;
    e.preventDefault();

    $(".gift_wrap_checkbox:checkbox").each(function() {
      if ($(this).is(':checked')) {
        variant = $(this)
      }
    })

    $('.giftwrap_select_option').each(function() {
      if ($(this).is(':checked')) {
        variant = $(this)
      }
    })

    if(explain.val() == '') {
      error.css("display", "block")
      return
    }
  
    const formData = {
      items: [
        {
          id: variant.val(),
          quantity: currentQuantity,
          properties: {
            'ברכה': note.val(),
            'הנחיות': explain.val()
          }
        }
      ]
    };

    $(this).attr('disabled', 'disabled');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
      .then(resp => resp.json())
      .then(data => {
        $(this).removeAttr('disabled');
        document.dispatchEvent(new CustomEvent("cart:refresh"));
      })
      .catch(err => {
        console.error('Error: ', err);
      });
      $(".overlay").removeClass("is-on");
})

$(".gift_wrap_checkbox:checkbox").on('change', function() {
  var $box = $(this);
  if ($box.is(":checked")) {
    var group = ".gift_wrap_checkbox:checkbox[name='" + $box.attr("name") + "']";
    $(group).prop("checked", false);
    $box.prop("checked", true);
  } else {
    $box.prop("checked", false);
  }
});


function add_gift_wrap(e, el) {
    const note = $('.GiftWrap__Note')
    const explain = $('.GiftWrap__Explain')
    const error = $('.Giftwrap__error')
  
    let variant = ""
    const currentQuantity = $('.gift_wrap_quantity .QuantitySelector__CurrentQuantity').val()
    e = e || window.event;
    e.preventDefault();

    $(".gift_wrap_checkbox:checkbox").each(function() {
      if ($(this).is(':checked')) {
        variant = $(this)
      }
    })

    if(explain.val() == '') {
      error.css("display", "block")
      return
    }
  
    const formData = {
      items: [
        {
          id: variant.val(),
          quantity: currentQuantity,
          properties: {
            'ברכה': note.val(),
            'הנחיות': explain.val()
          }
        }
      ]
    };

    el.setAttribute('disabled', 'disabled');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
      .then(resp => resp.json())
      .then(data => {
        el.removeAttribute('disabled');
        document.documentElement.dispatchEvent(
          new CustomEvent('product:added', {
            bubbles: true,
            detail: {
              variant: variant.val(),
              quantity: currentQuantity,
              properties: {
                'ברכה': note.val(),
                'הנחיות': explain.val()
              }
            }
          })
        );
      })
      .catch(err => {
        console.error('Error: ', err);
      });
      $(".overlay").removeClass("is-on");
}

function closeSubmenu(el) {
  if (el.classList.contains('SubSub_close')) {
    const parent = document.querySelectorAll(".Collapsible__Button[aria-expanded=true]")
    const collapsible = parent[1].parentNode
    const inner = parent[1].nextElementSibling
    parent[1].setAttribute("aria-expanded", "false")
    collapsible.style.overflow = "hidden"
    inner.style.overflow = "hidden"
  } else {
      const parent = document.querySelector(".Collapsible__Button[aria-expanded=true]")
      const collapsible = parent.parentNode
      const inner = parent.nextElementSibling
      parent.setAttribute("aria-expanded", "false")
      collapsible.style.overflow = "hidden"
      inner.style.overflow = "hidden"
  }
}

window.addEventListener('load', function () {
  const pplr_c_button = document.querySelector('.pplr-c-button')
  const product_cnt = document.querySelector('.Product')
  
  if (pplr_c_button != null && product_cnt != null) {
    if (product_cnt.getAttribute('data-zepto-hebrew') == 'false') {
       pplr_c_button.addEventListener('click', () => {
        const pplr_texts = document.querySelectorAll('.pplr_text')
        pplr_texts.forEach(input => {
          input.addEventListener('change', () => {
            let str = input.value
            str = str.replace(/[^0-9a-zA-Z♡&.\/\-+ ]+/g,'');
            input.value = str
          })
        })
      }) 
    }
  }
})

$( document ).ready(function() {

  $('.giftwrap_select_option').on('change', function(event) {
    const labelText = $(this).parent('label').text().trim();
    $('#popover-variant-dropdown-giftwrap-selected-value').text(labelText);
    $('#popover-variant-dropdown-giftwrap-selected-value').css('opacity', 1)
  })

  $('a.prod label').on('click', function (event) {
    event.preventDefault(); // Prevent the default behavior of the label
    window.location.href = $(this).parent().parent().attr('href');
    const input = $(this).attr('for'); // Get the associated input ID
    if (input) {
      $(`#${input}`).trigger('click'); // Trigger a click on the associated input
    }
  });
  
  var modelError = $('.error-model')
  var chkColor = $('.csbundle:checked').val()
  $('#colorBundle').val(chkColor)
  $('.bundcolor .cont').text(chkColor)


  $('.csbundle').click( function() {
      var id = $(this).data('sel')
      var parent = $(this).parents('.bundcolor')
      var ind = $(parent).find('span.cont')
      var data = $(this).val() 
      $(ind).text(data) 

      $(modelError).hide()
      $(this).removeClass('red')
      $('#colorBundle').val('')
      $('#modelBundle').val('')

       var index = $(`.Carousel__Cell[data-varimg="${data}"]`).data('media-position')
      
      /*var flkty = new Flickity('.Product__Slideshow');
      flkty.select( index - 1 );*/

      if ($(window).width() > 1008 ) {
          var el = $('.Product__Slideshow').find(`[data-varimg=${data}]`)
          if (el.length) {
              $('html, body').animate({
                  scrollTop: $(el).offset().top
              }, 500);
          }

      }


      // $('.Product__Gallery').hide()
      $('.selecTor').hide()
      $(`.selecTor[data-sel="${id}"]`).show()
      parent.find('.ProductForm__Label').removeClass('red')

      $(`.selecTor[data-sel="${id}"]`).find('.bund-sel option').show()

      var prodID = $(`.selecTor[data-sel="${id}"]`).find('.bund-sel option:selected').data('productid')
      var varId = $(`.selecTor[data-sel="${id}"]`).find('.bund-sel option:selected').data('var')
      var varName = $(`.selecTor[data-sel="${id}"]`).find('.bund-sel option:selected').text()

      
      $("#selItems").val(varName + ' - ' +  data)
      $('#colorBundle').val(prodID)
      $('#modelBundle').val(varId)

      // $(`.Product__Gallery[data-sel="${id}"]`).show()

      if ( !$('#colorBundle').val() == "" ) {
          $('.bundcolor span.ProductForm__Label').removeClass('red')
          $('.bundle-add').removeAttr('disabled')
      }
      // var $carousel = $('.Product__Slideshow')
      // $carousel.flickity('resize')
  })

    if ($('.bund-sel option:checked').length > 0 ) {
        var activeColor = $('.csbundle:checked').data('sel')
        var activeColorName = $('.csbundle:checked').val()
        var index = $(this).parents('.selecTor')
        var index = $(index).data('sel')
        var modelValue = $(`.selecTor[data-sel="${activeColor}"]`).find('.bund-sel option:checked')
        var inActives = $('.selecTor').not(`.selecTor[data-sel="${activeColor}"]`)
        var unCheckeds = $(inActives).find('.bund-sel option:checked')

        var varName = $(`.selecTor[data-sel="${activeColor}"]`).find('.bund-sel option:selected').text()
            
        $(unCheckeds).attr('checked', false)
        $('.bund-sel option:checked').attr('checked', false)
        $('#modelBundle').val($(modelValue).data('var'))
        
        $("#selItems").val(varName + ' - ' + activeColorName)
    }
    $('.bund-sel').on('change', function() {
        var prodID = $(this).find(":selected").data('productid')
        var id = $(this).find(":selected").data('var')
        var parent = $(this).parents('.bundmodel')
        var data = $(this).val()
        var colorName = $('.csbundle:checked').val()

        $('#colorBundle').val('')
        $('#modelBundle').val('')

        $("#selItems").val(data + ' - ' +  colorName)
        $('#colorBundle').val(prodID)
        $('#modelBundle').val(id)

        if ( !$('#modelBundle').val() == "" ) {
            $(modelError).hide()
            $('.bundle-add').removeAttr('disabled')
        }

        if ($(this).val() != "") {
            $(this).parents('.selecTor').addClass('right-arr')
        } else {
            $(this).parents('.selecTor').removeClass('right-arr')
        }
        if ( data == null ) {
            modelError.show()   
            // $('.bundcolor .ProductForm__Label').addClass('red')
            $(this).find('option').show()
            $(this).addClass('red')
            $(this).parents('.selecTor').addClass('redded')
        } else {
            modelError.hide()
            $(this).find('option').show()
            $(this).removeClass('red')
            $(this).parents('.selecTor').removeClass('redded')
        }
    })
    

    var csinput = $('input[data-sel="0"]:checked')
    
    if ( $('input[data-sel="0"]:checked').length > 0 ) {
        $('.selecTor[data-sel="0"]').show()
    }

    var csbundle = $('.csbundle:checked').data('sel')
    $(`.selecTor[data-sel="${csbundle}"]`).show()

    $('select.filt-sel').on('change', function() {
        $(this).parents('.filt-wrapper').addClass('right-arr')
        window.location.href = $(this).val()
    })
    
    $('.selecTor').on('change', function() {
		$('.ProductForm__AddToCart').removeClass('Button--secondary')
        $('.ProductForm__AddToCart').addClass('Button--primary')
        $('.ProductForm__AddToCart').text('הוסיפי לסל')
    })
});



